/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import {
  standardsAndFrameworkTypes,
  ViewValues,
  virtualTypes
} from '../survey-overview-sidebar/viewOptions';
import { DelegationScope, ScopeGroups } from '../../model/surveyData';
import { standards } from '@g17eco/core';

type VirtualScopeType = typeof virtualTypes[number];
type StandardsFrameworksTypes = typeof standardsAndFrameworkTypes[number];

export type DelegationScopeOptions = keyof DelegationScope | VirtualScopeType;

export const isVirtualType = (type: string): type is VirtualScopeType => {
  return virtualTypes.includes(type as VirtualScopeType);
}

export const isStandardFrameworkType = (type: ViewValues): type is StandardsFrameworksTypes => {
  return standardsAndFrameworkTypes.includes(type as StandardsFrameworksTypes);
}

const isVirtualScope = (scopeType: DelegationScopeOptions): scopeType is VirtualScopeType => {
  return virtualTypes.includes(scopeType as VirtualScopeType);
};

export const getDelegationScope = (delegationScope: DelegationScopeOptions, firstValue: string): keyof DelegationScope => {
  if (isVirtualScope(delegationScope)) {
    return standards[firstValue] ? ScopeGroups.Standards : ScopeGroups.Frameworks
  }
  return delegationScope
};
